import { createSlice, PayloadAction } from "@logicsoftware/redux-toolkit";
import { SpaceMembersByProjectPayload, SpaceMembersState } from "./types";

const initialState: SpaceMembersState["spaceMembersByProject"] = {};

export const {
    reducer,
    actions: { setSpaceMembersByProject },
} = createSlice({
    name: "spaceMembersByProject",
    initialState,
    reducers: {
        setSpaceMembersByProject: (state, { payload }: PayloadAction<SpaceMembersByProjectPayload>) => ({
            ...state,
            [payload.projectId]: payload.spaceMembers,
        }),
    },
});

export const getSpaceMembersByProject = (projectId: number) => (state: SpaceMembersState) =>
    state.spaceMembersByProject?.[projectId];
